const CustomerPesoSales = {
  "columns": 6,
  "rows": 2,
  "visual": {
    "id": 1,
    "type": "combo",
    "colorTheme": "colorTheme2",
    "title": "Peso Sales and Number of Customers/Branches",
    "orientation": "vertical",
    "xAxis": "",
    "yAxis": "",
    "binding": {
      "data": {
        "series": [
          {
            "name": 'Actual Sales',
            "value": 'ActualSales(Value)',
            "type": 'column'

          },
          {
            "name": 'Number of Accounts',
            "value": 'NumberOfAccounts',
            "type": 'line'
          }
        ],
        "title": 'CustomerGroup',
        "endpoint": "N53",
        "parameters": [
          { "key": "FromMonth", "value": "2024" },
          { "key": "FromYear", "value": "1" },
          { "key": "ToMonth", "value": "2024" },
          { "key": "ToYear", "value": "1" },
          { "key": "ConfigTypeCode", "value": "" }
        ]
      },
      "context": {
        "point": {
          "onClick": {
            "selectedValueColumn": "CustomerGroup",
            "selectedTitle": "Channel",
            "visual": [
              {
                "columns": 12,
                "rows": 2,
                "visual": {
                  "id": 1,
                  "type": "advancedTable",
                  "colorTheme": "colorTheme1",
                  "title": "Channel",
                  "binding": {
                    "data": {
                      "columns": [
                        {
                          "name": 'Channel',
                          "columnName": 'DistributorCode',
                          "width": '180px',
                          "align": "left",
                          "sortable": true,
                          "sum": false
                        },
                        {
                          "name": 'Actual Sales',
                          "columnName": 'ActualSales(Value)',
                          "width": '140px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'LY Sales',
                          "columnName": 'LYSales(Value)',
                          "width": '135px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Growth %',
                          "columnName": 'Growth(Value)',
                          "width": '135px',
                          "align": "right",
                          "sortable": true,
                          "sum": false,
                          "percent": true
                        }
                      ],
                      "title": 'DistributorCode',
                      "endpoint": "N53.1",
                      "parameters": [
                        { "key": "FromMonth", "value": "2024" },
                        { "key": "FromYear", "value": "1" },
                        { "key": "ToMonth", "value": "2024" },
                        { "key": "ToYear", "value": "1" },
                        { "key": "CustomerGroup", "value": "" },
                        { "key": "ConfigTypeCode", "value": "" }
                      ]
                    },
                    "context": {
                      "point": {
                        "onClick": {
                          "selectedValueColumn": "CustomerGroupDistributorCode",
                          "selectedTitle": "Customer",
                          "visual": [
                            {
                              "columns": 12,
                              "rows": 2,
                              "visual": {
                                "id": 1,
                                "type": "advancedTable",
                                "colorTheme": "colorTheme1",
                                "title": "Customer",
                                "binding": {
                                  "data": {
                                    "columns": [
                                      {
                                        "name": 'Customer Name',
                                        "columnName": 'CustomerName',
                                        "width": '300px',
                                        "align": "left",
                                        "sortable": true,
                                        "sum": false
                                      },
                                      {
                                        "name": 'Actual Sales',
                                        "columnName": 'ActualSales(Value)',
                                        "width": '140px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                      },
                                      {
                                        "name": 'LY Sales',
                                        "columnName": 'LYSales(Value)',
                                        "width": '135px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                      },
                                      {
                                        "name": 'Growth %',
                                        "columnName": 'Growth(Value)',
                                        "width": '135px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": false,
                                        "percent": true
                                      }
                                    ],
                                    "title": 'CustomerName',
                                    "endpoint": "N53.2",
                                    "parameters": [
                                      { "key": "FromMonth", "value": "2024" },
                                      { "key": "FromYear", "value": "1" },
                                      { "key": "ToMonth", "value": "2024" },
                                      { "key": "ToYear", "value": "1" },
                                      { "key": "CustomerGroupDistributorCode", "value": "" },
                                      { "key": "ConfigTypeCode", "value": "" }
                                    ]
                                  },
                                  "context": {
                                    "point": {
                                      "onClick": {
                                        "selectedValueColumn": "CustomerGroupDistributorCodeCustomerCode",
                                        "selectedTitle": "Product",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "Product",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'Product Name',
                                                      "columnName": 'ItemName',
                                                      "width": '300px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Actual Sales',
                                                      "columnName": 'ActualSales(Value)',
                                                      "width": '140px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'LY Sales',
                                                      "columnName": 'LYSales(Value)',
                                                      "width": '135px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Growth %',
                                                      "columnName": 'Growth(Value)',
                                                      "width": '135px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": false,
                                                      "percent": true
                                                    }
                                                  ],
                                                  "title": 'ItemName',
                                                  "endpoint": "N53.3",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "CustomerGroupDistributorCodeCustomerCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {

                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          ]
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }
  }
}

const CustomerGroupShare = {
  "columns": 6,
  "rows": 2,
  "visual": {
    "id": 1,
    "type": "pie",
    "colorTheme": "colorTheme1",
    "title": "Share by Customer Group Sales",
    "binding": {
      "data": {
        "title": 'CustomerGroup',
        "value": 'Share(Value)',
        "tooltip": 'ActualSales(Value)',
        "currency": true,
        "percent": true,
        "endpoint": "N53",
        "parameters": [
          { "key": "FromMonth", "value": "2024" },
          { "key": "FromYear", "value": "1" },
          { "key": "ToMonth", "value": "2024" },
          { "key": "ToYear", "value": "1" },
          { "key": "ConfigTypeCode", "value": "" }
        ]
      },
      "context": {
        "point": {
          "onClick": {
            "selectedValueColumn": "CustomerGroup",
            "selectedTitle": "Channel",
            "visual": [
              {
                "columns": 12,
                "rows": 2,
                "visual": {
                  "id": 1,
                  "type": "advancedTable",
                  "colorTheme": "colorTheme1",
                  "title": "Channel",
                  "binding": {
                    "data": {
                      "columns": [
                        {
                          "name": 'Channel',
                          "columnName": 'DistributorCode',
                          "width": '180px',
                          "align": "left",
                          "sortable": true,
                          "sum": false
                        },
                        {
                          "name": 'Actual Sales',
                          "columnName": 'ActualSales(Value)',
                          "width": '140px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'LY Sales',
                          "columnName": 'LYSales(Value)',
                          "width": '135px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Growth %',
                          "columnName": 'Growth(Value)',
                          "width": '135px',
                          "align": "right",
                          "sortable": true,
                          "sum": false,
                          "percent": true
                        }
                      ],
                      "title": 'DistributorCode',
                      "endpoint": "N53.1",
                      "parameters": [
                        { "key": "FromMonth", "value": "2024" },
                        { "key": "FromYear", "value": "1" },
                        { "key": "ToMonth", "value": "2024" },
                        { "key": "ToYear", "value": "1" },
                        { "key": "CustomerGroup", "value": "" },
                        { "key": "ConfigTypeCode", "value": "" }
                      ]
                    },
                    "context": {
                      "point": {
                        "onClick": {
                          "selectedValueColumn": "CustomerGroupDistributorCode",
                          "selectedTitle": "Customer",
                          "visual": [
                            {
                              "columns": 12,
                              "rows": 2,
                              "visual": {
                                "id": 1,
                                "type": "advancedTable",
                                "colorTheme": "colorTheme1",
                                "title": "Customer",
                                "binding": {
                                  "data": {
                                    "columns": [
                                      {
                                        "name": 'Customer Name',
                                        "columnName": 'CustomerName',
                                        "width": '300px',
                                        "align": "left",
                                        "sortable": true,
                                        "sum": false
                                      },
                                      {
                                        "name": 'Actual Sales',
                                        "columnName": 'ActualSales(Value)',
                                        "width": '140px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                      },
                                      {
                                        "name": 'LY Sales',
                                        "columnName": 'LYSales(Value)',
                                        "width": '135px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": true
                                      },
                                      {
                                        "name": 'Growth %',
                                        "columnName": 'Growth(Value)',
                                        "width": '135px',
                                        "align": "right",
                                        "sortable": true,
                                        "sum": false,
                                        "percent": true
                                      }
                                    ],
                                    "title": 'CustomerName',
                                    "endpoint": "N53.2",
                                    "parameters": [
                                      { "key": "FromMonth", "value": "2024" },
                                      { "key": "FromYear", "value": "1" },
                                      { "key": "ToMonth", "value": "2024" },
                                      { "key": "ToYear", "value": "1" },
                                      { "key": "CustomerGroupDistributorCode", "value": "" },
                                      { "key": "ConfigTypeCode", "value": "" }
                                    ]
                                  },
                                  "context": {
                                    "point": {
                                      "onClick": {
                                        "selectedValueColumn": "CustomerGroupDistributorCodeCustomerCode",
                                        "selectedTitle": "Product",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "Product",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'Product Name',
                                                      "columnName": 'ItemName',
                                                      "width": '300px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Actual Sales',
                                                      "columnName": 'ActualSales(Value)',
                                                      "width": '140px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'LY Sales',
                                                      "columnName": 'LYSales(Value)',
                                                      "width": '135px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Growth %',
                                                      "columnName": 'Growth(Value)',
                                                      "width": '135px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": false,
                                                      "percent": true
                                                    }
                                                  ],
                                                  "title": 'ItemName',
                                                  "endpoint": "N53.3",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "CustomerGroupDistributorCodeCustomerCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {

                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          ]
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }
  }
}

const CustomerGroupComparative = {
  "columns": 12,
  "rows": 2,
  "visual": {
    "id": 1,
    "type": "advancedTable",
    "colorTheme": 'colorTheme1',
    "title": "Customer Group Comparative Sales",
    "binding": {
      "data": {
        "columns": [
          {
            "name": 'Customer Group',
            "columnName": 'CustomerGroup',
            "width": '200px',
            "align": "left",
            "sortable": true,
            "sum": false
          },
          {
            "name": 'Jan',
            "columnName": 'Jan',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Feb',
            "columnName": 'Feb',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Mar',
            "columnName": 'Mar',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Apr',
            "columnName": 'Apr',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'May',
            "columnName": 'May',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Jun',
            "columnName": 'Jun',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Jul',
            "columnName": 'Jul',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Aug',
            "columnName": 'Aug',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Sep',
            "columnName": 'Sep',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Oct',
            "columnName": 'Oct',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Nov',
            "columnName": 'Nov',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Dec',
            "columnName": 'Dec',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          },
          {
            "name": 'Total Sales',
            "columnName": 'TotalSales',
            "width": '125px',
            "align": "right",
            "sortable": true,
            "sum": true
          }
        ],
        "title": "CustomerGroup",
        "endpoint": "N74",
        "parameters": [
          { "key": "FromMonth", "value": "2024" },
          { "key": "FromYear", "value": "1" },
          { "key": "ToMonth", "value": "2024" },
          { "key": "ToYear", "value": "1" },
          { "key": "ConfigTypeCode", "value": "" }
        ]
      },
      "context": {
        "point": {
          "onClick": {
            "selectedTitle": 'Channel',
            "selectedValueColumn": 'CustomerGroup',
            "visual": [
              {
                "columns": 12,
                "rows": 2,
                "visual": {
                  "id": 1,
                  "type": "advancedTable",
                  "colorTheme": "colorTheme1",
                  "title": "Channel",
                  "binding": {
                    "data": {
                      "columns": [
                        {
                          "name": 'Channel Code',
                          "columnName": 'DistributorCode',
                          "width": '150px',
                          "align": "left",
                          "sortable": true,
                          "sum": false
                        },
                        {
                          "name": 'Channel Name',
                          "columnName": 'DistributorName',
                          "width": '200px',
                          "align": "left",
                          "sortable": true,
                          "sum": false
                        },
                        {
                          "name": 'Jan',
                          "columnName": 'Jan',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Feb',
                          "columnName": 'Feb',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Mar',
                          "columnName": 'Mar',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Apr',
                          "columnName": 'Apr',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'May',
                          "columnName": 'May',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Jun',
                          "columnName": 'Jun',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Jul',
                          "columnName": 'Jul',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Aug',
                          "columnName": 'Aug',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Sep',
                          "columnName": 'Sep',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Oct',
                          "columnName": 'Oct',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Nov',
                          "columnName": 'Nov',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Dec',
                          "columnName": 'Dec',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        },
                        {
                          "name": 'Total Sales',
                          "columnName": 'TotalSales',
                          "width": '125px',
                          "align": "right",
                          "sortable": true,
                          "sum": true
                        }
                      ],
                      "title": 'DistributorName',
                      "endpoint": "N74.7",
                      "parameters": [
                        { "key": "FromMonth", "value": "2024" },
                        { "key": "FromYear", "value": "1" },
                        { "key": "ToMonth", "value": "2024" },
                        { "key": "ToYear", "value": "1" },
                        { "key": "CustomerGroup", "value": "" },
                        { "key": "ConfigTypeCode", "value": "" }
                      ]
                    },
                    "context": {
                      "point": {
                        "onClick": {
                          "selectedValueColumn": 'CustomerGroup',
                          "visuals": [
                            {
                              "title": "Region",
                              "visual": [
                                {
                                  "columns": 12,
                                  "rows": 2,
                                  "visual": {
                                    "id": 1,
                                    "type": "advancedTable",
                                    "colorTheme": "colorTheme1",
                                    "title": "Region",
                                    "binding": {
                                      "data": {
                                        "columns": [
                                          {
                                            "name": 'Region',
                                            "columnName": 'RegionCode',
                                            "width": '150px',
                                            "align": "left",
                                            "sortable": true,
                                            "sum": false
                                          },
                                          {
                                            "name": 'Jan',
                                            "columnName": 'Jan',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Feb',
                                            "columnName": 'Feb',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Mar',
                                            "columnName": 'Mar',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Apr',
                                            "columnName": 'Apr',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'May',
                                            "columnName": 'May',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Jun',
                                            "columnName": 'Jun',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Jul',
                                            "columnName": 'Jul',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Aug',
                                            "columnName": 'Aug',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Sep',
                                            "columnName": 'Sep',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Oct',
                                            "columnName": 'Oct',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Nov',
                                            "columnName": 'Nov',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Dec',
                                            "columnName": 'Dec',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Total Sales',
                                            "columnName": 'TotalSales',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          }
                                        ],
                                        "title": 'RegionCode',
                                        "endpoint": "N74.1",
                                        "parameters": [
                                          { "key": "FromMonth", "value": "2024" },
                                          { "key": "FromYear", "value": "1" },
                                          { "key": "ToMonth", "value": "2024" },
                                          { "key": "ToYear", "value": "1" },
                                          { "key": "CustomerGroup", "value": "" },
                                          { "key": "ConfigTypeCode", "value": "" }
                                        ]
                                      },
                                      "context": {
                                        "point": {
                                          "onClick": {
                                            "selectedValueColumn": "CustomerGroupRegionCode",
                                            "selectedTitle": "Customer",
                                            "visual": [
                                              {
                                                "columns": 12,
                                                "rows": 2,
                                                "visual": {
                                                  "id": 1,
                                                  "type": "advancedTable",
                                                  "colorTheme": "colorTheme1",
                                                  "title": "Customer",
                                                  "binding": {
                                                    "data": {
                                                      "columns": [
                                                        {
                                                          "name": 'Customer Name',
                                                          "columnName": 'CustomerName',
                                                          "width": '200px',
                                                          "align": "left",
                                                          "sortable": true,
                                                          "sum": false
                                                        },
                                                        {
                                                          "name": 'Jan',
                                                          "columnName": 'Jan',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Feb',
                                                          "columnName": 'Feb',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Mar',
                                                          "columnName": 'Mar',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Apr',
                                                          "columnName": 'Apr',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'May',
                                                          "columnName": 'May',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Jun',
                                                          "columnName": 'Jun',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Jul',
                                                          "columnName": 'Jul',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Aug',
                                                          "columnName": 'Aug',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Sep',
                                                          "columnName": 'Sep',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Oct',
                                                          "columnName": 'Oct',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Nov',
                                                          "columnName": 'Nov',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Dec',
                                                          "columnName": 'Dec',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Total Sales',
                                                          "columnName": 'TotalSales',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        }
                                                      ],
                                                      "title": 'CustomerName',
                                                      "onLoad": 'Pgn.N74.4',
                                                      "subtotal": true,
                                                      "pagination": {
                                                        "show": true
                                                      },
                                                      "endpoint": "N74.4",
                                                      "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "CustomerGroupRegionCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" },
                                                        { "key": "PageIndex", "value": "1" },
                                                        { "key": "ResultsPerPage", "value": "10" }
                                                      ]
                                                    },
                                                    "context": {
                                                      "point": {
                                                        "onClick": {

                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "title": "District",
                              "visual": [
                                {
                                  "columns": 12,
                                  "rows": 2,
                                  "visual": {
                                    "id": 1,
                                    "type": "advancedTable",
                                    "colorTheme": "colorTheme1",
                                    "title": "District",
                                    "binding": {
                                      "data": {
                                        "columns": [
                                          {
                                            "name": 'District Manager Name',
                                            "columnName": 'DistrictManagerName',
                                            "width": '250px',
                                            "align": "left",
                                            "sortable": true,
                                            "sum": false
                                          },
                                          {
                                            "name": 'District Name',
                                            "columnName": 'DistrictName',
                                            "width": '180px',
                                            "align": "left",
                                            "sortable": true,
                                            "sum": false
                                          },
                                          {
                                            "name": 'Region',
                                            "columnName": 'RegionCode',
                                            "width": '110px',
                                            "align": "left",
                                            "sortable": true,
                                            "sum": false
                                          },
                                          {
                                            "name": 'Jan',
                                            "columnName": 'Jan',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Feb',
                                            "columnName": 'Feb',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Mar',
                                            "columnName": 'Mar',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Apr',
                                            "columnName": 'Apr',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'May',
                                            "columnName": 'May',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Jun',
                                            "columnName": 'Jun',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Jul',
                                            "columnName": 'Jul',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Aug',
                                            "columnName": 'Aug',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Sep',
                                            "columnName": 'Sep',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Oct',
                                            "columnName": 'Oct',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Nov',
                                            "columnName": 'Nov',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Dec',
                                            "columnName": 'Dec',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Total Sales',
                                            "columnName": 'TotalSales',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          }
                                        ],
                                        "title": 'DistrictManagerName',
                                        "endpoint": "N74.2",
                                        "parameters": [
                                          { "key": "FromMonth", "value": "2024" },
                                          { "key": "FromYear", "value": "1" },
                                          { "key": "ToMonth", "value": "2024" },
                                          { "key": "ToYear", "value": "1" },
                                          { "key": "CustomerGroup", "value": "" },
                                          { "key": "ConfigTypeCode", "value": "" }
                                        ]
                                      },
                                      "context": {
                                        "point": {
                                          "onClick": {
                                            "selectedValueColumn": "CustomerGroupDistrictRegionCode",
                                            "selectedTitle": "Customer",
                                            "visual": [
                                              {
                                                "columns": 12,
                                                "rows": 2,
                                                "visual": {
                                                  "id": 1,
                                                  "type": "advancedTable",
                                                  "colorTheme": "colorTheme1",
                                                  "title": "Customer",
                                                  "binding": {
                                                    "data": {
                                                      "columns": [
                                                        {
                                                          "name": 'Customer Name',
                                                          "columnName": 'CustomerName',
                                                          "width": '200px',
                                                          "align": "left",
                                                          "sortable": true,
                                                          "sum": false
                                                        },
                                                        {
                                                          "name": 'Jan',
                                                          "columnName": 'Jan',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Feb',
                                                          "columnName": 'Feb',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Mar',
                                                          "columnName": 'Mar',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Apr',
                                                          "columnName": 'Apr',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'May',
                                                          "columnName": 'May',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Jun',
                                                          "columnName": 'Jun',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Jul',
                                                          "columnName": 'Jul',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Aug',
                                                          "columnName": 'Aug',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Sep',
                                                          "columnName": 'Sep',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Oct',
                                                          "columnName": 'Oct',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Nov',
                                                          "columnName": 'Nov',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Dec',
                                                          "columnName": 'Dec',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Total Sales',
                                                          "columnName": 'TotalSales',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        }
                                                      ],
                                                      "title": 'CustomerName',
                                                      "onLoad": 'Pgn.N74.5',
                                                      "subtotal": true,
                                                      "pagination": {
                                                        "show": true
                                                      },
                                                      "endpoint": "N74.5",
                                                      "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "CustomerGroupDistrictRegionCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" },
                                                        { "key": "PageIndex", "value": "1" },
                                                        { "key": "ResultsPerPage", "value": "10" }
                                                      ]
                                                    },
                                                    "context": {
                                                      "point": {
                                                        "onClick": {

                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              "title": "PMR",
                              "visual": [
                                {
                                  "columns": 12,
                                  "rows": 2,
                                  "visual": {
                                    "id": 1,
                                    "type": "advancedTable",
                                    "colorTheme": "colorTheme1",
                                    "title": "PMR",
                                    "binding": {
                                      "data": {
                                        "columns": [
                                          {
                                            "name": 'PMR Code',
                                            "columnName": 'AgentCode',
                                            "width": '150px',
                                            "align": "left",
                                            "sortable": true,
                                            "sum": false
                                          },
                                          {
                                            "name": 'Employee Code',
                                            "columnName": 'EmployeeCode',
                                            "width": '150px',
                                            "align": "left",
                                            "sortable": true,
                                            "sum": false
                                          },
                                          {
                                            "name": 'PMR Name',
                                            "columnName": 'AgentName',
                                            "width": '150px',
                                            "align": "left",
                                            "sortable": true,
                                            "sum": false
                                          },
                                          {
                                            "name": 'Area Name',
                                            "columnName": 'TerritoryName',
                                            "width": '300px',
                                            "align": "left",
                                            "sortable": true,
                                            "sum": false
                                          },
                                          {
                                            "name": 'District Name',
                                            "columnName": 'DistrictName',
                                            "width": '200px',
                                            "align": "left",
                                            "sortable": true,
                                            "sum": false
                                          },
                                          {
                                            "name": 'Region',
                                            "columnName": 'RegionCode',
                                            "width": '110px',
                                            "align": "left",
                                            "sortable": true,
                                            "sum": false
                                          },
                                          {
                                            "name": 'Jan',
                                            "columnName": 'Jan',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Feb',
                                            "columnName": 'Feb',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Mar',
                                            "columnName": 'Mar',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Apr',
                                            "columnName": 'Apr',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'May',
                                            "columnName": 'May',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Jun',
                                            "columnName": 'Jun',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Jul',
                                            "columnName": 'Jul',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Aug',
                                            "columnName": 'Aug',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Sep',
                                            "columnName": 'Sep',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Oct',
                                            "columnName": 'Oct',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Nov',
                                            "columnName": 'Nov',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Dec',
                                            "columnName": 'Dec',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          },
                                          {
                                            "name": 'Total Sales',
                                            "columnName": 'TotalSales',
                                            "width": '125px',
                                            "align": "right",
                                            "sortable": true,
                                            "sum": true
                                          }
                                        ],
                                        "title": 'AgentName',
                                        "endpoint": "N74.3",
                                        "parameters": [
                                          { "key": "FromMonth", "value": "2024" },
                                          { "key": "FromYear", "value": "1" },
                                          { "key": "ToMonth", "value": "2024" },
                                          { "key": "ToYear", "value": "1" },
                                          { "key": "CustomerGroup", "value": "" },
                                          { "key": "ConfigTypeCode", "value": "" }
                                        ]
                                      },
                                      "context": {
                                        "point": {
                                          "onClick": {
                                            "selectedValueColumn": "CustomerGroupAgentRegionCode",
                                            "selectedTitle": "Customer",
                                            "visual": [
                                              {
                                                "columns": 12,
                                                "rows": 2,
                                                "visual": {
                                                  "id": 1,
                                                  "type": "advancedTable",
                                                  "colorTheme": "colorTheme1",
                                                  "title": "Customer",
                                                  "binding": {
                                                    "data": {
                                                      "columns": [
                                                        {
                                                          "name": 'Customer Name',
                                                          "columnName": 'CustomerName',
                                                          "width": '200px',
                                                          "align": "left",
                                                          "sortable": true,
                                                          "sum": false
                                                        },
                                                        {
                                                          "name": 'Jan',
                                                          "columnName": 'Jan',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Feb',
                                                          "columnName": 'Feb',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Mar',
                                                          "columnName": 'Mar',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Apr',
                                                          "columnName": 'Apr',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'May',
                                                          "columnName": 'May',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Jun',
                                                          "columnName": 'Jun',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Jul',
                                                          "columnName": 'Jul',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Aug',
                                                          "columnName": 'Aug',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Sep',
                                                          "columnName": 'Sep',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Oct',
                                                          "columnName": 'Oct',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Nov',
                                                          "columnName": 'Nov',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Dec',
                                                          "columnName": 'Dec',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        },
                                                        {
                                                          "name": 'Total Sales',
                                                          "columnName": 'TotalSales',
                                                          "width": '125px',
                                                          "align": "right",
                                                          "sortable": true,
                                                          "sum": true
                                                        }
                                                      ],
                                                      "title": 'CustomerName',
                                                      "onLoad": 'Pgn.N74.6',
                                                      "subtotal": true,
                                                      "pagination": {
                                                        "show": true
                                                      },
                                                      "endpoint": "N74.6",
                                                      "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "CustomerGroupAgentRegionCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" },
                                                        { "key": "PageIndex", "value": "1" },
                                                        { "key": "ResultsPerPage", "value": "10" }
                                                      ]
                                                    },
                                                    "context": {
                                                      "point": {
                                                        "onClick": {

                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      }
                    }
                  }
                }


              }
            ]
          }
        }
      }
    }
  }
}

export const CustomerSales = {
  "sections": [
    CustomerPesoSales,
    CustomerGroupShare,
    CustomerGroupComparative
  ]
}